import React, { useState, useRef, useEffect } from "react";
import Bredcrum from "../../components/bredcrum";
import { Tag } from "primereact/tag";
import { Tablescom } from "../../components/tablescomp";
import { Toast } from "primereact/toast";

import { userservices } from "../../services/userServices";
import { productservices } from "../../services/productServices";
import { supplierservices } from "../../services/supplierServices";
import { manufacturingServices } from "../../services/manufacturingServices";
import { manufacturerServices } from "../../services/manufacturerServices";


import { Titlebar, Searchbox, Label } from "../../components/fieldsComp";
import  { useLocation } from "react-router";

function Editmanufacturer() {
  const location = useLocation(null);  
  const toast = useRef(null);
  const [errors, setErrors] = useState({});
  const [productnamesku, setProductnamesku] = useState('');
  const [productlist,setProductlist] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    contact_person: "",
    gst_no: "",
    country: "",
    state: "",
    city: "",
    website: "",
    notes: "",
    status: "active",
  });


  useEffect(()=>{
    setFormData(location.state?.manufacturer);
  },[]);

const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
};


  const validate = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.email) newErrors.email = "Email is required";
    if (!formData.phone || isNaN(formData.phone)) newErrors.phone = "Phone number is required";
    // if (!formData.date || isNaN(formData.date)) newErrors.date = "Created Date is required";
    if (!formData.address) newErrors.address = "Address is required";
    if (!formData.contact_person) newErrors.contact_person = "Contact Person is required";
    if (!formData.country) newErrors.country = "Country is required";
    if (!formData.city) newErrors.city = "City is required";

    // Add other field validations as needed

    return newErrors;
  };

  const refs = {
    name: useRef(null),
    email: useRef(null),
    phone: useRef(null),
    // date: useRef(null),
    address: useRef(null),
    contact_person: useRef(null),
    country: useRef(null),
    city: useRef(null),
  };


  const handlesubmit = (e) => {
     e.preventDefault();
        const validationErrors = validate();
          setErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) {
      // Focus first input with error
          const firstErrorKey = Object.keys(validationErrors)[0];
          if (refs[firstErrorKey]) {
            refs[firstErrorKey].current.focus();
          }
      return;
    }
    let dataToSend = { ...formData };
        manufacturerServices.editmanufacturer(dataToSend).then((response)=>{
            if(response.status == 200){
                toast.current.show({ severity: 'success', summary: 'Manufacturer', detail: 'Manufacturer updated successfully' }); 
            }else{
                toast.current.show({ severity: 'error', summary: 'Manufacturer', detail: `${response.data.data}` }); 
            }   
        }).catch((error)=>{
            toast.current.show({ severity: 'error', summary: 'Manufacturer', detail: 'Error' }); 
        });
    

    // Handle form submission here
  };

  const handleClose = () => {
    // Reset form or close modal logic
    console.log('Form Closed');
  };



  return (
    <>
      <Toast ref={toast} />
      <Bredcrum title={"Product/addproduct"} divider={false} />
      <div class="row">
        {/* <div className='col-md-12 mb-4 mt-4'>
                 <div className='flex-box flex-between'>
                      <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color custom-btn-style'>Add New Product</button> 
                      <Searchbox/>
                  </div> 
              </div>  */}

        <Titlebar text={"Edit Manufacturer"} />
        <div className="col-md-12 mt-3">
          <div className="card ps-5 pe-5">
            <div className="card-body card-body-style">
              <div className="row">
                <div className="container mt-4"></div>
                <form onSubmit={(e) => handlesubmit(e)}>

                        <div class="row mb-3">
                            <div class="col-md-6">
                            <label for="name" class="form-label">Name</label>
                            <input type="text"  onChange={handleChange} ref={refs.name} class="form-control"
                             id="name" name="name" placeholder="Enter Name" value={formData.name}/>
                             {errors.name && <span style={{ color: "red" }}>{errors.name}</span>}
                            </div>
                            <div class="col-md-6">
                            <label for="email" class="form-label">Email</label>
                            <input type="email"  onChange={handleChange} ref={refs.email} class="form-control" id="email" 
                            name="email" placeholder="Enter Email" value={formData.email}/>
                             {errors.email && <span style={{ color: "red" }}>{errors.email}</span>}
                            </div>
                           
                        </div>

                        <div class="row mb-3">
                          <div class="col-md-6">
                            <label for="phone" class="form-label">Phone</label>
                            <input type="number" ref={refs.phone} class="form-control" 
                            id="phone" name="phone" placeholder="Enter Phone Number"  value={formData.phone} onChange={handleChange} />
                             {errors.phone && <span style={{ color: "red" }}>{errors.phone}</span>}
                         </div>
                        <div class="col-md-6">
                            <label for="address" class="form-label">Address</label>
                            <input type="text" ref={refs.address} class="form-control" 
                            id="address" name="address" placeholder="Enter Address" value={formData.name} onChange={handleChange} />
                             {errors.address && <span style={{ color: "red" }}>{errors.address}</span>}
                         </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4">
                            <label for="contact_person" class="form-label">Contact Person</label>
                            <input type="text" placeholder="Enter Contact Person" ref={refs.contact_person} class="form-control" 
                            id="contact_person" name="contact_person" value={formData.contact_person} onChange={handleChange}/>
                            {errors.contact_person && <span style={{ color: "red" }}>{errors.contact_person}</span>}
                            </div>
                            <div class="col-md-4">
                            <label for="gst_no" class="form-label">GST NO</label>
                            <input type="text"  placeholder="Enter GST NO" class="form-control" id="gst_no" name="gst_no"  
                            value={formData.gst_no} onChange={handleChange}/>
                            </div>
                            <div class="col-md-4">
                            <label for="country" class="form-label">Country</label>
                            <input type="text" ref={refs.country} placeholder="Enter Country" class="form-control" id="country" 
                            name="country"  value={formData.country} onChange={handleChange}/>
                            {errors.country && <span style={{ color: "red" }}>{errors.country}</span>}
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-md-4">
                                <label for="state" class="form-label">State</label>
                                <input type="text" ref={refs.state} placeholder="Enter State" class="form-control" id="state" 
                                name="state"  onChange={handleChange} value={formData.state}/>
                                {errors.state && <span style={{ color: "red" }}>{errors.state}</span>}
                            </div>

                            <div class="col-md-4">
                                <label for="city" class="form-label">City</label>
                                <input type="text" ref={refs.city} placeholder="Enter City" 
                                class="form-control" id="city" name="city"  value={formData.city} onChange={handleChange}/>
                                {errors.city && <span style={{ color: "red" }}>{errors.city}</span>}
                            </div>

                            <div class="col-md-4">
                                <label for="website" class="form-label">Website</label>
                                <input type="text" ref={refs.website} 
                                placeholder="Enter Website" class="form-control" 
                                id="website" name="website" value={formData.website}  onChange={handleChange}/>
                            </div>

                        </div>

                        <div class="row mb-3">

                          <div class="col-md-8">
                            <label for="notes" class="form-label">Remarks</label>
                            <textarea class="form-control" id="notes" name="notes" value={formData.notes} rows="3" placeholder="Enter Notes"  onChange={handleChange}></textarea>
                          </div>
                        <div class="col-md-4">
                            <label for="status" class="form-label">Status</label>
                            <select class="form-select" id="status" name="status" value={formData.status}  ref={refs.status}  onChange={handleChange}>
                               <option value="">Select Status</option> 
                                <option value="active">Active</option>
                                <option value="">Inactive</option>
                            </select>
                            {errors.status && <span style={{ color: "red" }}>{errors.status}</span>}
                            </div>
                        </div>


                    <div class="row">
                      <div class="col-md-6">
                        <button type="submit" class="btn color-white me-2 w-100 rounded custom-btn-br-color custom-btn-color">Update</button></div>
                      <div class="col-md-6">
                      <button type="button" class="btn color-white w-100 rounded custom-btn-color-secondary">Close</button>
                      </div>
                      </div>
                        {/* <button type="submit" class="btn color-white me-2 w-100 rounded custom-btn-br-color custom-btn-color">Submit</button> */}

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Editmanufacturer;
